import 'jquery-mask-plugin/dist/jquery.mask.min.js'

function initPhoneMask($el) {
  $el.mask("(999) 999-9999", { clearIfNotMatch: true });
};

$(document).on('turbo:load', function () {
  $("[type=tel]").mask("(999) 999-9999", { clearIfNotMatch: true });

  // Phone Mask
  initPhoneMask($('[type=tel]'));
});
